// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__24-Pm","noInteraction":"EventWrapper_noInteraction__1O3Qr","pointerPassthrough":"EventWrapper_pointerPassthrough__UP6v_"};